import React, { Fragment, useEffect } from "react";
import BreachHeaderText from "./BreachHeaderText";
import BreachesTab from "./BreachesTab";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import CreditAccordion from "../Credit/CreditAccordion";

const faqList = [
    {
        id: "safety-score",
        sectionHeading: "ID Safety Score",
        headers: ["How can I improve my score?", "What factors affect my score?", "If my ID Safety Score is 100, does that mean I’m perfectly safe?"],
        content: [
            "Improve your ID Safety Score by completing the actions in your action plan. These recommendations are based on decades of research and personalized for your individual breach history.",
            "Many factors combine to make your ID Safety Score. First, we look at the number of breaches you've been in and how risky those breaches were. Then, we look at the top identity crime risks you face because of those breaches. We also look at how many actions you’ve completed in your action plan. There are more factors contributing to your ID Safety Score, but these are the most important for you to know right now.",
            "While having a score of 100 means you've done a great job protecting your identity, there’s no way to be perfectly safe from identity crime. Keep following your action plan and check back often to stay on top of new breaches you may be involved in.",
        ],
    },
    {
        id: "action-plan",
        sectionHeading: "Action Plan",
        headers: ["How are my open actions generated?", "Why should I complete my open actions?"],
        content: [
            "The actions in your action plan are based on your individual breach history and the top identity crime risks you face because of it. Actions we recommend come from years of identity theft and crime research conducted by our experts.",
            "Your action plan is tailored specifically for you, so it's one of the best ways to protect your identity. Taking some time to complete actions now can save much more time later if it helps you avoid identity theft or fraud.",
        ],
    },
    {
        id: "breach-exposures",
        sectionHeading: "Breach Exposures",
        headers: [
            "What is the dark web?",
            "What is a breach?",
            "How does BreachIQ detect breaches?",
            "Are you showing all the breaches I’ve ever been exposed in? ",
        ],
        content: [
            "When a data breach occurs, the stolen data often ends up on the dark web—a kind of internet “black market” where criminals buy and sell information. The dark web is an encrypted part of the internet that can only be accessed with specialized web browsers.",
            "A breach is when the security of your data has been compromised, usually by hacking, ransomware, accidental exposure or some other way. This can lead to criminals gaining access to sensitive information to use for fraud.",
            "We regularly scan the dark web to see where your personal information shows up, usually as a result of a breach. We also have a large database of every publicly reported breach in the United States. Whenever you learn that you’ve been a victim of a breach, search this database for the breach by its name and save it to your profile. When any organization is breached, they’re required to notify consumers. It’s easy for these notifications to end up in an overlooked email folder or secondary email account, so keep an eye out for them.",
            "The dark web only contains data from a small portion of all reported breaches. So, scanning for your data there probably doesn’t capture every breach you’ve ever been involved in. To improve the accuracy of your profile, recommended actions and ID Safety Score, you should add all of your email accounts into the Identity Vault. You should also use the search tool to manually save breaches you remember being a part of.",
        ],
    },
    {
        id: "protecting-data",
        sectionHeading: "Protecting My Data",
        headers: ["What is personally identifiable information (PII)?"],
        content: [
            "Personally identifiable information, or PII, is personal data that can identify a specific person either by itself or when combined with other info. Some examples are your Social Security number, bank account number, driver’s license number or even your name and date of birth. Other examples include medical, educational and employment data.",
        ],
    },
];
function BreachFaq() {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);
    return (
        <Fragment>
            <div className="row">
                <BreachHeaderText />
            </div>
            <BreachesTab selectedTab="5" />
            <div className="row" id="content">
                <div className="col-xs-12 col-sm-12">
                    <div className="box">
                        <div className="box-header padding-left-5rem">
                            <div className="box-title-container">
                                <div className="box-title-icon action-bulb-icon-main flex" aria-hidden="true" style={{ display: "flex" }}>
                                    <RenderIcons iconName="comments" />
                                </div>
                                <div className="box-title-text" style={{ paddingTop: 3 }}>
                                    <h2 className="breach-section-title">Frequently Asked Questions</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content padding-left-5rem">
                            {faqList.map((item) => (
                                <Fragment key={item.id}>
                                    <div className="box-title-container" style={{ marginTop: 20 }}>
                                        <div className="box-header">
                                            <div className="box-title-text">
                                                <h3 className="breach-section-title">{item.sectionHeading}</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-description">
                                        <CreditAccordion
                                            headers={item.headers.map((v: any, i: number) => (
                                                <Fragment key={`${v}-${i}`}>{v}</Fragment>
                                            ))}
                                            content={item.content.map((v: any, i: number) => (
                                                <p style={{ paddingLeft: "0.5rem", marginBottom: "1rem" }} key={i}>
                                                    {v}
                                                </p>
                                            ))}
                                            itemId={`collapsed-text-${item.id}`}
                                        />
                                    </div>
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default BreachFaq;
